import { NextPayoutsTableTablesWithData } from './next-payouts/table';
import { GlobalPayoutsChartWithData } from './stats/global-payouts';

export function ManagePayouts(): JSX.Element {
  return (
    <div className="flex flex-col gap-5">
      <NextPayoutsTableTablesWithData />
      <GlobalPayoutsChartWithData />
    </div>
  );
}
